export default __webpack_public_path__ + "images/EZS.b11921c.png";